import { apiClient } from './apiClient';

export interface MeterExchangeData {
  date: string;
  export_kwh: number;
  import_kwh: number;
  net_energy_kwh: number;
  sync_status: boolean;
}

export interface MeterExchangeResponse {
  plant_name: string;
  date_range: string;
  chart_data: MeterExchangeData[];
  summary: {
    total_export_kwh: number;
    total_import_kwh: number;
    net_export_kwh: number;
    sync_issues_count: number;
    sync_percentage: number;
  };
}

export interface SyncValidationResponse {
  plant_name: string;
  sync_validation: {
    total_days_checked: number;
    synced_days: number;
    sync_percentage: number;
    status: 'healthy' | 'warning' | 'critical';
  };
  recent_data: MeterExchangeData[];
}

export const meterExchangeService = {
  async getExportImportData(plantId: string, dateRange?: string): Promise<MeterExchangeResponse> {
    const params = new URLSearchParams({ plant_id: plantId });
    if (dateRange) params.append('date_range', dateRange);
    
    const response = await apiClient.get(`/api/monitoring/meter/export-import/?${params}`);
    return response.data;
  },

  async getSyncValidation(plantId: string): Promise<SyncValidationResponse> {
    const params = new URLSearchParams({ plant_id: plantId });
    const response = await apiClient.get(`/api/monitoring/meter/sync-validation/?${params}`);
    return response.data;
  }
};